import { useContext } from "react";
import { pluralize } from "@common/helpers/string";
import { ImporterContext } from "./importer.context";
import styles from "./ImporterPage.module.scss";
import { documentBeingProcessed } from "./helpers";

export const ImporterPageStatus: React.FC = () => {
    const { documentRows } = useContext(ImporterContext);
    const processedDocuments = documentRows.filter(
        (row) =>
            row.financialDocument &&
            !documentBeingProcessed(row.financialDocument),
    );

    const transactionsNumber = processedDocuments.reduce(
        (acc, row) => acc + (row.financialDocument?.numTransactions ?? 0),
        0,
    );

    return (
        <div className={styles.pageStatus}>
            {documentRows.length > 0 ? (
                <span className={styles.pageStatusItem}>
                    Processed {processedDocuments.length} of{" "}
                    {documentRows.length}{" "}
                    {pluralize("document", documentRows.length)}
                </span>
            ) : (
                <span className={styles.pageStatusItem}>
                    Processed 0 documents
                </span>
            )}
            <span className={styles.pageStatusItem}>
                {transactionsNumber} transactions
            </span>
        </div>
    );
};
